export default 
{
  formation: {
    grade: '',
    level: '',
    to_date: '',
    institute: '',
    from_date: '',
    scholarity: '',
    certificate: '',
    popupActive: false,
  },
  formations: [],
}
